import { UserStatus } from '@/types/legacyUserStatus';

export enum ActionTypes {
  FETCH_USER_STATUS_START = 'userStatus/FETCH_USER_STATUS_START',
  FETCH_USER_STATUS_UPDATE = 'userStatus/FETCH_USER_STATUS_UPDATE',
  FETCH_USER_STATUS_SUCCESS = 'userStatus/FETCH_USER_STATUS_SUCCESS',
  FETCH_USER_STATUS_FAIL = 'userStatus/FETCH_USER_STATUS_FAIL',
  FETCH_PROMOTION_RESET = 'userStatus/FETCH_PROMOTION_RESET',
  FETCH_PROMOTION_OK = 'userStatus/FETCH_PROMOTION_OK',
  UPDATE_PROMOTIONS_AVAILABLE = 'userStatus/UPDATE_PROMOTIONS_AVAILABLE',
  UPDATE_TAGS = 'userStatus/UPDATE_TAGS',
  CLEAN_USER_STATUS = 'userStatus/CLEAN_USER_STATUS',
}

export interface State {
  isLoading: boolean;
  mustUpdate: boolean;
  error: string;
  data?: UserStatus;
  lastPromotionGenerator?: string | null;
  isUserBlocked?: boolean;
}

export interface FetchUserStatusStartAction {
  type: ActionTypes.FETCH_USER_STATUS_START;
}
export interface FetchPromotionResetAction {
  type: ActionTypes.FETCH_PROMOTION_RESET;
}
export interface FetchPromotionOkAction {
  type: ActionTypes.FETCH_PROMOTION_OK;
  payload?: boolean;
}
export interface FetchUserStatusUpdateAction {
  type: ActionTypes.FETCH_USER_STATUS_UPDATE;
}
export interface FetchUserStatusSuccessAction {
  type: ActionTypes.FETCH_USER_STATUS_SUCCESS;
  payload: UserStatus;
}
export interface FetchUserStatusFailAction {
  type: ActionTypes.FETCH_USER_STATUS_FAIL;
  payload: string;
}
export interface UpdatePromotionsAvailableAction {
  type: ActionTypes.UPDATE_PROMOTIONS_AVAILABLE;
  payload: number;
}
export interface UpdateTagsAction {
  type: ActionTypes.UPDATE_TAGS;
  payload: string[] | [] | undefined;
}
export interface cleanUserStatusAction {
  type: ActionTypes.CLEAN_USER_STATUS;
}

export type ActionType =
  | FetchPromotionResetAction
  | FetchPromotionOkAction
  | FetchUserStatusStartAction
  | FetchUserStatusUpdateAction
  | FetchUserStatusSuccessAction
  | FetchUserStatusFailAction
  | UpdatePromotionsAvailableAction
  | UpdateTagsAction
  | cleanUserStatusAction;
